import logo from './logo.svg';
import './App.css';
import GooglePlay from './GooglePlay.png';
import AppStore from './AppleStore.png';
import UpstriveHome from './UpstriveHomeLogo.png';
import AlkalmaHome from './AlkalmaHomeLogo.png';
import { useEffect, useState } from 'react';
import ValidateAccountModal from './modals/ValidateAccountModal';
import { isMobile, isTablet } from 'react-device-detect';
import { useSearchParams } from 'react-router-dom';

function App() {
	const url = window.location;
	const pathName = window?.location?.pathname ?? '';
	const search = window?.location?.search ?? '';
	const mobileUrl = `alkalma-xp:/${pathName}${search}`;
	const isValidateAccount = pathName.includes('validate');
	const searchParams = new URLSearchParams(window.location.search);
	const [showValidateModal, setShowValidateModal] = useState(false);

	const email = searchParams.get('email') ?? null;
	const token = searchParams.get('token') ?? null;

	useEffect(() => {
		if (!!isMobile || !!isTablet) {
			const timeout = setTimeout(() => {
				window.open(mobileUrl, '_self');
			}, 1000);
			return () => clearTimeout(timeout);
		} else if (!!isValidateAccount && !isMobile && !isTablet) {
			setTimeout(() => {
				setShowValidateModal(true);
			}, 400);
		}
	}, [isMobile, isTablet]);

	return (
		<div className='App'>
			<header className='App-header'>
				<div className='mobile-view'>
					<div style={{ marginBottom: 10, padding: '0 50px' }}>
						<img src={UpstriveHome} alt='App Store Button' className='home-image' />
					</div>

					<div className='body'>
						<div style={{ marginBottom: 30, marginTop: 30 }}>
							<img src={AlkalmaHome} alt='App Store Button' className='home-image' />
						</div>
						<p className='description'>You will be automatically redirected to the app</p>
						<p className='label'>
							If you are still on this page,
							<br />
							<a href={mobileUrl} className='highlight'>
								redirect to the app
							</a>
							{isValidateAccount && (
								<>
									{/* <br />
									or <br />
									<a href={mobileUrl} className='highlight'>
										validate account yourself
									</a> */}
								</>
							)}
						</p>
						<div style={{ display: 'flex', gap: '10', flexDirection: 'row', marginTop: 40 }}>
							<div>
								<a href='https://apps.apple.com/app/id6764344767' target='_blank' className='store-button'>
									<img src={AppStore} alt='App Store Button' className='store-button' />
								</a>
							</div>
							<div>
								<a href='https://play.google.com/store/apps/details?id=com.upstrive.alkalmaXpApp' target='_blank' className='store-button'>
									<img src={GooglePlay} alt='Google Play Button' className='store-button' />
								</a>
							</div>
						</div>
					</div>
				</div>
				<ValidateAccountModal modalIsOpen={showValidateModal} email={email} token={token} />
				{/* <span>{mobileUrl}</span> */}
			</header>
		</div>
	);
}

export default App;
